import { Link } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import userPhoto from "../assets/def_profile_photo.png";

import { Edit } from "react-feather";

import Typography from "@mui/material/Typography";

function DashboardProfile() {
  const { profile, error } = useAuth();
  return (
    <div>
      {error && <p className="error-message">Something went wrong...</p>}
      {profile && (
        <>
          <div className="profile">
            <Link to={`/dashboard/profile/edit`} className="icon-button">
              <Edit size={19} />
              <span className="icon-text">Edit</span>
            </Link>
            <div className="section">
              <Typography variant="h1" component="div" sx={{ flexGrow: 0 }}>
                My Profile
              </Typography>
              <img
                alt="a bowl of noodles"
                className="user-photo"
                src={userPhoto}
                style={{ marginTop: "30px" }}
              />
              <h3 className="subheader">Username</h3>
              <span>{profile.username}</span>
              <h3 className="subheader">Name</h3>
              <p className="remark centered">(Hidden from the public)</p>
              <span>{profile.name}</span>
              <h3 className="subheader">E-mail</h3>
              <p className="remark centered">(Hidden from the public)</p>
              <span>{profile.email}</span>
              <h3 className="subheader">Bio</h3>
              <span>{profile.bio}</span>
              <h3 className="subheader">Favorite Food</h3>
              <span>{profile.favorite_food}</span>
            </div>
          </div>
          <div style={{ marginTop: "20px" }} className="profile">
            <div className="section">
              <Typography
                variant="h1"
                component="div"
                sx={{ flexGrow: 0, marginBottom: 5 }}
              >
                Settings
              </Typography>
              <h3 className="subheader">Newsletter:</h3>{" "}
              <p className="remark centered">
                {profile.newsletter_subscribed
                  ? "You're subscribed"
                  : "You're not subscribed"}
              </p>
              <Link to={`/dashboard/profile/edit`} className="icon-button">
                <Edit size={19} />
                <span className="icon-text">Edit</span>
              </Link>
            </div>
          </div>
          <div className="section">
            <Link
              to="/dashboard"
              className="back-button"
              style={{ textDecoration: "underline" }}
            >
              ← Back to Dashboard
            </Link>
          </div>
        </>
      )}
    </div>
  );
}

export default DashboardProfile;
